import * as React from 'react';
import { FunctionComponent } from 'react';
import { ACTION_TYPE } from 'Src/components/GeneralMessageActionsButton/GeneralMessageActionsButton';

interface Props {
  hasNext: boolean;
  hasPrevious: boolean;
  onNextClick: () => void;
  onPreviousClick: () => void;
  onSaveClick?: () => void;
  onSendClick: () => void;
  onScheduleClick?: () => void;
  onActiveActionChange?: (actionType: ACTION_TYPE) => void;
  onCancelClick: () => void;
  isNextButtonDisabled?: boolean;
  isError?: boolean;
  isLoading?: boolean;
  isScheduleFormVisible?: boolean;
}

export const CreateGeneralMessageButtons: FunctionComponent<Props> = props => {
  const {
    hasNext,
    hasPrevious,
    onNextClick,
    onPreviousClick,
    onSaveClick,
    onSendClick,
    onScheduleClick,
    onActiveActionChange,
    onCancelClick,
    isNextButtonDisabled,
    isError,
    isLoading,
    isScheduleFormVisible
  } = props;
  const isFinalDisabled = Boolean(isNextButtonDisabled || isError || isLoading);
  const onScheduleActionClick = () => onActiveActionChange && onActiveActionChange(ACTION_TYPE.SCHEDULE);
  const onCancelSchedulingClick = () => onActiveActionChange && onActiveActionChange(ACTION_TYPE.SEND);

  return (
    <div className="gmComposerButtons">
      <div className="gmComposerButtons__left">
        <button type="button" className="gmButton gmButton--secondary" disabled={isLoading} onClick={onCancelClick}>
          Cancel
        </button>
      </div>
      <div className="gmComposerButtons__right">
        {hasPrevious && (
          <button type="button" className="gmButton gmButton--secondary" disabled={isLoading} onClick={onPreviousClick}>
            Previous
          </button>
        )}
        {onSaveClick && (
          <button type="button" className="gmButton gmButton--secondary" disabled={isLoading} onClick={onSaveClick}>
            {isLoading ? 'Saving…' : 'Save draft'}
          </button>
        )}
        {hasNext && (
          <button
            type="button"
            className="gmButton gmButton--primary"
            onClick={onNextClick}
            disabled={isNextButtonDisabled}
          >
            Next
          </button>
        )}
        {!hasNext && (
          <div className="gmComposerButtons__final">
            {isScheduleFormVisible ? (
              <>
                <button
                  type="button"
                  className="gmButton gmButton--secondary"
                  disabled={isLoading}
                  onClick={onCancelSchedulingClick}
                >
                  Cancel scheduling
                </button>
                <button
                  type="button"
                  className="gmButton gmButton--primary"
                  disabled={isFinalDisabled}
                  onClick={onScheduleClick}
                >
                  {isLoading ? 'Scheduling…' : 'Confirm schedule'}
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  className="gmButton gmButton--secondary"
                  disabled={isFinalDisabled}
                  onClick={onScheduleActionClick}
                >
                  Schedule
                </button>
                <button
                  type="button"
                  className="gmButton gmButton--primary"
                  disabled={isFinalDisabled}
                  onClick={onSendClick}
                >
                  {isLoading ? 'Sending…' : 'Send now'}
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
